import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GetApiClientDocument } from '@/graphql/generated/getApiClient.generated';
import { DevOnboardingDialog } from './DevOnboardingDialog';

export default function DevOnboarding() {
    const [open, setOpen] = useState(false);

    useQuery(GetApiClientDocument, {
        onCompleted: (data) => {
            if (!data.getApiClient?.primaryKeyGeneratedAt) {
                setOpen(true);
            }
        },
    });

    const handleComplete = () => {
        setOpen(false);
    };

    if (!open) {
        return null;
    }

    return <DevOnboardingDialog open={open} onComplete={handleComplete} />;
}
